import React, { useState } from 'react';
import { Container, Spinner } from "react-bootstrap";
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import DashboardTab from '../../../components/clockResgistry/DashboardTab/DashboardTab';
import HistoryTab from '../../../components/clockResgistry/HistoryTab/HistoryTab';

import './Clock.css';

const Clock = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('dashboard');
  
  const { user } = useSelector((state) => state.auth || {});

  return (
    <Container fluid className="clock-page">

      <div className="clock-header">
        <h2 className="txt-main m-0 fw-bold">
          {t('pages.Clock.title')}
        </h2>

        <div className="clock-tabs">
          <button
            className={`btn ${
              activeTab === 'dashboard'
                ? 'btn-primary'
                : 'btn-secondary border-0 bg-transparent'
            }`}
            onClick={() => setActiveTab('dashboard')}
          >
            {t('pages.Clock.dashboard')}
          </button>

          <button
            className={`btn ${
              activeTab === 'history'
                ? 'btn-primary'
                : 'btn-secondary border-0 bg-transparent'
            }`}
            onClick={() => setActiveTab('history')}
          >
            {t('pages.Clock.history')}
          </button>
        </div>
      </div>

      <div className="tab-content">
        {activeTab === 'dashboard' ? (
          <DashboardTab />
        ) : user?.id ? (
          <HistoryTab userId={user.id} />
        ) : (
          <div className="d-flex justify-content-center align-items-center p-5">
            <Spinner animation="border" variant="primary" />
          </div>
        )}
      </div>

    </Container>
  );
};

export default Clock;